/**
 * 会員情報更新 JS
 *
 */

{

// API 送信
  // --------------------------------------------------------
  const submitForm = async (data, formType) => {

    const res = await Promise.all([
      fetch(`/tools/seiban-backend-app/customer/${formType}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        }
      })
    ])
    .then(responses => Promise.all(responses.map(response => response.json())))
    .then(dataArray => {
      // success プロパティが無い場合に補完する
      const normalized = dataArray.map(item => {
        // オブジェクト以外（配列・文字列など）が返ってきた場合
        if (!item || typeof item !== 'object' || Array.isArray(item)) {
          return { success: true, data: item };
        }

        // すでに success がある場合はそのまま
        if ('success' in item) return item;

        // エラーとみなす条件
        const isError =
          (item.status !== undefined && Number(item.status) >= 400) ||
          !!item.error ||
          !!item.errors;

        return { ...item, success: !isError };
      });

      console.log('Success:', normalized);
      return normalized;
    })
    .catch((error) => {
      console.error('Error:', error);
      // 後工程で res[0].success を参照するため、必ず配列で返す
      return [{ success: false, message: '通信エラーが発生しました。' }];
    });

    return res;
  }


  // 誕生日のセット
  // --------------------------------------------------------
  const childBirthdays = (form)=>{
    const birthday_space = form.querySelectorAll('[data-target-birthday]');
    console.log({birthday_space})
    if(!birthday_space) return;
    birthday_space.forEach(birthday => {
      const target_birthday = birthday.getAttribute('data-target-birthday');
      const year = birthday.querySelector('select[name*="year"]');
      const month = birthday.querySelector('select[name*="month"]');
      const day = birthday.querySelector('select[name*="day"]');


      year.addEventListener('change', ()=>{
        setBirthday(year.value, month.value, day.value);
      });
      month.addEventListener('change', ()=>{
        setBirthday(year.value, month.value, day.value);
      });
      day.addEventListener('change', ()=>{
        setBirthday(year.value, month.value, day.value);
      });

      function setBirthday(year, month, day) {
        const formattedMonth = month.toString().padStart(2, '0');
        const formattedDay = day.toString().padStart(2, '0');
        const birthday = `${year}-${formattedMonth}-${formattedDay}`;
        // birthday.value = birthday
        const target_birthday_element = document.querySelector(`[name="${target_birthday}"]`);
        target_birthday_element.value = birthday;
      }

    });
  }


  // 郵便番号の自動入力
  // --------------------------------------------------------
  const zipAutoInput = (form)=>{
    const zip = form.querySelector('[name="zip"]');
    const province = form.querySelector('[name="province"]');
    const city = form.querySelector('[name="city"]');
    const address1 = form.querySelector('[name="address1"]');

    if(!zip || !province || !city || !address1) return;

    zip.addEventListener('input', (e)=>{
      const zipCode = toHalfWidth(e.target.value).replace(/-/g, '');
      if(zipCode.length === 7) {
      fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipCode}`)
        .then(response => response.json())
        .then(data => {
          if(data?.status === 200) {
            const fetchedProvince = data?.results[0]?.address1;
            const fetchedCity = data?.results[0]?.address2;
            const fetchedAddress1 = data?.results[0]?.address3;
            zip.value = zipCode;
            province.value = fetchedProvince;
            city.value = fetchedCity;
            address1.value = fetchedAddress1;
          }
        })
        .catch(error => {
            console.error('Error:', error);
          });
      }
    });
  }

  // 電話番号の半角修正
  // --------------------------------------------------------
  const phoneHalfWidth = (form)=>{
    const phone = form.querySelectorAll('[name="phone"]');
    if(!phone) return;
    phone.forEach(phone => {
      phone.addEventListener('change', (e)=>{
        phone.value = toHalfWidth(phone.value);
      });
    });
  }

  function toHalfWidth(str) {
    return str.replace(/[０-９ー]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {

    const form = document.querySelector('#customer-form');
    const submitButton = document.querySelector('#submit-button');
    const formType = form.getAttribute('data-formtype') || 'update';
    console.log({formType})

    childBirthdays(form);
    zipAutoInput(form);
    phoneHalfWidth(form);


    // フォーム送信
    // --------------------------------------------------------
    submitButton.addEventListener('click', async function(e) {
      e.preventDefault();
      submitButton.classList.add('submitting');

      form.querySelectorAll('.sbn-c-validate').forEach(validate => {
        validate.classList.remove('error');
      });

      const formData = new FormData(form);
      const data = {};
      formData.forEach((value, key) => {
        data[key] = value;
      });
      console.log({data});

      const validate_res = formCheck();
      console.log({validate_res});

      if(validate_res.length > 0) {
        submitButton.classList.remove('submitting');
        alert('入力に誤りがあります。修正してください。');
        // 一番上のエラーまでスクロール
        const firstError = validate_res[0];
        const firstErrorElement = document.querySelector(`[name="${firstError.name}"]`);
        if(firstErrorElement) {
          firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      // API送信
      const res = await submitForm(data, formType);
      console.log(JSON.stringify(res));

      if(formType === 'email-update'){
        if(res[0].status != '400'){
          alert('保存しました');
          submitButton.classList.remove('submitting');
          window.location.href = '/account';
        }else{
          const error_message = res[0].message || '保存時にエラーが発生しました。';
          alert(error_message);
          submitButton.classList.remove('submitting');
        }

      }else{
        if(res[0].success) {
          submitButton.classList.add('disabled');
          if(data['sm_rankup']) {
            alert('情報登録に成功しました。SEIBANスマイルメンバーズへのご登録ありがとうございました。');
          }else{
            alert('保存しました');
          }
          submitButton.classList.remove('submitting');
          window.location.href = '/account';
        } else {
          const error_message = res[0].message || '保存時にエラーが発生しました。';
          // error_messageに日本語がなければ
          if(!error_message.match(/^[あ-んア-ン一-龥]/)) {
            alert('保存時にエラーが発生しました。');
          }else{
            alert(error_message);
          }
          submitButton.classList.remove('submitting');
        }
      }

    });


    // バリデーション
    const formCheck = () => {


      const requiredValidationMap = {
        "last_name": '.sbn-c-validate-name',
        "first_name": '.sbn-c-validate-name',
        "custom._last_name": '.sbn-c-validate-name',
        "custom._first_name": '.sbn-c-validate-name',
        "zip": '.sbn-c-validate-zip',
        "province": '.sbn-c-validate-prefecture',
        "city": '.sbn-c-validate-city',
        "address1": '.sbn-c-validate-address',
        "phone": '.sbn-c-validate-phone',
        "email": '.sbn-c-validate-email',
        "custom._gender": '.sbn-c-validate-gender',
        "custom._birthday": '.sbn-c-validate-birthday',
        "custom._register_timing": '.sbn-c-validate-register_timing',
        "custom._child_relation": '.sbn-c-validate-child_relation',
        "custom._child_firstname_1": '.sbn-c-validate-child_name',
        "custom._child_lastname_1": '.sbn-c-validate-child_name',
        "custom._child_gender_1": '.sbn-c-validate-gender',
        "custom._child_firstname-kana_1": '.sbn-c-validate-child_name_kana',
        "custom._child_lastname-kana_1": '.sbn-c-validate-child_name_kana',
        "custom._child_birth_1": '.sbn-c-validate-child_birthday',
      };

      const error = [];

      // 必須項目チェック
      const requiredFields = form.querySelectorAll('[required]');
      requiredFields.forEach(field => {
        const wrapper = field.closest('.sbn-c-formtable-application__row');

        // Check if field is empty based on its type
        let isEmpty = false;

        if (field.type === 'radio') {
          isEmpty = !form.querySelector(`input[name="${field.name}"]:checked`);
        } else if (field.type === 'checkbox') {
          isEmpty = !field.checked;
        } else {
          isEmpty = !field.value.trim();
        }

        let validateText = null;

        if (requiredValidationMap[field.name]) {
          validateText = wrapper.querySelector(requiredValidationMap[field.name]);
          if (validateText) {
            if (isEmpty) {
              console.log(field.name, "未入力");
              validateText.classList.add('error');
              error.push({
                name: field.name,
                message: "未入力"
              });
            } else if (!error.includes(field.name)) {
              validateText.classList.remove('error');
            }
          }
        }
      });

      // メールアドレス一致
      if(form.querySelector('[name="email"]') && form.querySelector('[name="email_confirm"]')){
        const email = form.querySelector('[name="email"]').value;
        const email_confirm = form.querySelector('[name="email_confirm"]').value;


        console.log({email, email_confirm})

        if(email != email_confirm) {
          const validateText = form.querySelector('.sbn-c-validate-emailconfirmerror');
          if(validateText) {
            validateText.classList.add('error');
            error.push({
              name: 'email_not_match',
              message: "メールアドレスが一致しません"
            });
          }
        }
      }

      // 半角英数字チェック
      const halfWidthValidationMap = {
        "phone": '.sbn-c-validate-phone-invalid',
      };
      const halfWidthFields = form.querySelectorAll('[name="phone"]');
      halfWidthFields.forEach(field => {
        const wrapper = field.closest('.sbn-c-formtable-application__row');
        if(halfWidthValidationMap[field.name]) {
          validateText = wrapper.querySelector(halfWidthValidationMap[field.name]);
          if(validateText) {
            console.log({validateText})
            if(!field.value.match(/^[0-9]+$/)) {
              validateText.classList.add('error');
              error.push({
                name: field.name,
                message: "半角英数字で入力してください"
              });
            }
          }
        }
      });

      // 郵便番号のチェック
      if(form.querySelector('[name="zip"]')) {
        const zip = form.querySelector('[name="zip"]').value;
        if(!zip.match(/^\d{7}$/)) {
          const validateText = form.querySelector('.sbn-c-validate-zip-invalid');
          validateText.classList.add('error');
          error.push({
            name: 'zip',
            message: "郵便番号は7桁の半角数字で入力してください"
          });
        }
      }

      // 電話番号のチェック
      if(form.querySelector('[name="phone"]')){
        const phone = form.querySelector('[name="phone"]').value;
        if(!phone.match(/^0\d{9,10}$/)) {
          const validateText = form.querySelector('.sbn-c-validate-phone-invalid');
          validateText.classList.add('error');
          error.push({
            name: 'phone',
            message: "正しい電話番号を入力してください"
          });
        }
      }

      // カタカナチェック
      const kanaValidationMap = {
        "custom._last_name": '.sbn-c-validate-name-kana-invalid',
        "custom._first_name": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_1": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_1": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_2": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_2": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_3": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_3": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_4": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_4": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_5": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_5": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_6": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_6": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_7": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_7": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_8": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_8": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_9": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_9": '.sbn-c-validate-name-kana-invalid',
        "custom._child_lastname-kana_10": '.sbn-c-validate-name-kana-invalid',
        "custom._child_firstname-kana_10": '.sbn-c-validate-name-kana-invalid',
      };
      const kanaFields = form.querySelectorAll('[name="custom._last_name"], [name="custom._first_name"], [name*="custom._child_lastname-kana"], [name*="custom._child_firstname-kana"]');
      kanaFields.forEach(field => {
        if(!field.value) return;

        const wrapper = field.closest('.sbn-c-formtable-application__row');
        if(kanaValidationMap[field.name]) {
          validateText = wrapper.querySelector(kanaValidationMap[field.name]);
          if(validateText) {
            if(!field.value.match(/^[ァ-ヶー]+$/)) {
              validateText.classList.add('error');
              error.push({
                name: field.name,
                message: "カタカナで入力してください"
              });
            }
          }
        }
      });


      return error;
    }
  });

}
